import { StsConfigStaticLoader } from "angular-auth-oidc-client";
import { ConfigService } from "@core/services/config.service";

export const authFactory = (configService: ConfigService) => {
  const config = configService.getAuthModuleConfig();
  return new StsConfigStaticLoader(config);
};
